// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingScreen_container__2Cbsm","fade-out":"LoadingScreen_fade-out__1phOB"};